var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scene-wrapper"},[(_vm.video.url)?_c('Video',{attrs:{"src":_vm.video.url,"muted":_vm.$store.state.sound.muted},on:{"ended":_vm.advance}}):_vm._e(),_vm._v(" "),_c('Button',{staticClass:"performance-btn",attrs:{"action":_vm.advance}},[_vm._v(_vm._s(_vm.buttonText))])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18f59986","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/game/scenes/Performance.vue
// module id = null
// module chunks = 